<section class="mobile-product-details-shell" [attr.lang]="language()">
  <header class="details-navbar">
    <button type="button" class="ghost-btn" (click)="goBack()">{{ t('back') }}</button>
    <button type="button" class="ghost-btn" (click)="goToCart()">{{ t('viewCart') }}</button>
  </header>

  @if (product(); as currentProduct) {
    <article class="details-card">
      <div class="details-layout">
        <section class="details-main">
          <h1>{{ productName(currentProduct) }}</h1>
          <p class="details-description">{{ productDescription(currentProduct) }}</p>

          @if (currentProduct.categories.length > 0) {
            <section class="meta-group">
              <h2>{{ t('categories') }}</h2>
              <div class="chips-wrap">
                @for (category of currentProduct.categories; track category.id) {
                  <span>{{ categoryName(category) }}</span>
                }
              </div>
            </section>
          }

          @if (currentProduct.videoLink) {
            <section class="video-wrap">
              <h2>{{ t('productVideo') }}</h2>
              <video controls preload="none" [src]="currentProduct.videoLink"></video>
            </section>
          }

          <section class="purchase-box">
            <h2>{{ t('details') }}</h2>

            <div class="purchase-grid">
              <label>
                <span>{{ t('quantity') }}</span>
                <input
                  type="number"
                  [min]="packageSize()"
                  [step]="packageSize()"
                  [value]="normalizedSelectedQuantity()"
                  (input)="setQuantity($any($event.target).value)"
                />
                <small class="pack-note">{{ t('packIncrementHint') }} {{ packageSize() }}</small>
              </label>

              <div>
                <span>{{ t('unitPrice') }}</span>
                <strong>{{ unitPrice() | moneyComma }}</strong>
              </div>

              <div>
                <span>{{ t('lineTotal') }}</span>
                <strong>{{ lineTotal() | moneyComma }}</strong>
              </div>
            </div>

            <div class="actions-wrap">
              <button type="button" class="primary-btn" (click)="addToCart()">{{ t('addToCart') }}</button>
              @if (addedNotice()) {
                <small>{{ t('added') }}</small>
              }
            </div>
          </section>

          <div class="contact-pricing-wrap">
            <a class="contact-pricing-link" [href]="'tel:' + phoneHref">{{ t('contactPricing') }}</a>
          </div>
        </section>

        <aside class="details-media" aria-label="Product image slider">
          @if (imageURLs().length > 0) {
            <div class="media-stage">
              <img [src]="activeImageURL()" [alt]="productName(currentProduct)" loading="eager" decoding="async" />

              @if (hasMultipleImages()) {
                <button type="button" class="slide-nav prev" (click)="showPreviousImage()" aria-label="Previous image">&#8249;</button>
                <button type="button" class="slide-nav next" (click)="showNextImage()" aria-label="Next image">&#8250;</button>
              }
            </div>

            @if (hasMultipleImages()) {
              <div class="thumb-row" aria-label="Image thumbnails">
                @for (image of imageURLs(); track image; let imageIndex = $index) {
                  <button
                    type="button"
                    class="thumb-btn"
                    [class.active]="currentImageIndex() === imageIndex"
                    (click)="selectImage(imageIndex)"
                  >
                    <img [src]="image" [alt]="productName(currentProduct)" loading="lazy" decoding="async" />
                  </button>
                }
              </div>
            }
          } @else {
            <div class="media-placeholder">No image available.</div>
          }
        </aside>
      </div>
    </article>
  } @else if (loading()) {
    <p class="state-note">{{ t('loading') }}</p>
  } @else {
    <p class="state-note error-note">{{ t('notFound') }}</p>
  }
</section>
